import { HTTPError } from 'ky';

export class ContractActionClientError extends Error {
  readonly status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = 'ContractActionClientError';
    this.status = status;
  }
}

export function isContractActionClientError(
  error: unknown,
): error is ContractActionClientError {
  return error instanceof ContractActionClientError;
}

async function readDrfErrorDetail(response: Response): Promise<string> {
  try {
    const body = (await response.clone().json()) as {
      detail?: string | string[];
    };
    if (Array.isArray(body.detail)) {
      return body.detail.join(', ');
    }
    if (typeof body.detail === 'string' && body.detail.trim()) {
      return body.detail;
    }
  } catch {
    // not JSON — fall back to raw text below
  }

  const text = await response.text().catch(() => '');
  return text.trim() || 'Bad Request';
}

export async function handleContractActionRequest<T>(
  request: Promise<T>,
): Promise<T> {
  try {
    return await request;
  } catch (error) {
    if (error instanceof HTTPError) {
      const { status } = error.response;
      if (status >= 400 && status < 500) {
        const detail = await readDrfErrorDetail(error.response);
        throw new ContractActionClientError(status, detail);
      }
    }
    throw error;
  }
}
